import React, { useState } from 'react';
import { useInputMethodListeners } from '../../hooks/useInputMethodListeners';

export type InputMethod = 'keyboard' | 'mouse';

type Value = {
  inputMethod: InputMethod;
  setInputMethod: (inputMethod: InputMethod) => void;
};

const InputMethodContext = React.createContext<Value>({
  inputMethod: 'keyboard',
  setInputMethod: () => {
    throw new Error('InputMethod context not initialized');
  },
});

export const InputMethodContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [inputMethod, setInputMethod] = useState<InputMethod>('keyboard');
  useInputMethodListeners(inputMethod, setInputMethod);

  return (
    <InputMethodContext.Provider value={{ inputMethod, setInputMethod }}>
      {children}
    </InputMethodContext.Provider>
  );
};

export const useInputMethodContext = () => {
  return React.useContext(InputMethodContext);
};

export default InputMethodContext;
